var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStreakIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.27773 14.7777L6.22217 19.0554H15.3888L13.5555 30.0554L18.4444 23.3332L22.1111 18.4444L25.7778 12.9443H16.6111L18.4444 1.94434L12.9444 9.27767L9.27773 14.7777Z",
    fill: "#418DF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0555 12.9443H16.6111L18.4444 1.94434L12.9444 9.27767L9.27773 14.7777L6.22217 19.0554H12.9444L19.0555 12.9443Z",
    fill: "#9AC6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreakIcon);
export default __webpack_public_path__ + "static/media/StreakIcon.41fb52b596c8e8144c8417567e0893e1.svg";
export { ForwardRef as ReactComponent };